import { render, staticRenderFns } from "./TheProjects.vue?vue&type=template&id=009d5322&scoped=true&"
import script from "./TheProjects.vue?vue&type=script&lang=js&"
export * from "./TheProjects.vue?vue&type=script&lang=js&"
import style0 from "./TheProjects.vue?vue&type=style&index=0&id=009d5322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d5322",
  null
  
)

export default component.exports